module.exports = obj => Object.prototype.toString.call(obj) === '[object Array]'


// WEBPACK FOOTER //
// ./src/helpers/is_array.js


// WEBPACK FOOTER //
// webpack:///src/helpers/is_array.js